import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChecklistsIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M7.29747 5.82752H20.4375V7.67252H7.29747V5.82752ZM7.29747 13.2975V11.4525H20.4375V13.2975H7.29747ZM7.29747 18.9225V17.0775H20.4375V18.9225H7.29747ZM4.48497 16.5825C4.87497 16.5825 5.20871 16.725 5.48622 17.01C5.76372 17.295 5.90247 17.625 5.90247 18C5.90247 18.375 5.75997 18.7013 5.47497 18.9788C5.18996 19.2563 4.85997 19.395 4.48497 19.395C4.10996 19.395 3.78372 19.2563 3.50622 18.9788C3.22871 18.7013 3.08997 18.375 3.08997 18C3.08997 17.625 3.22496 17.295 3.49497 17.01C3.76497 16.725 4.09496 16.5825 4.48497 16.5825ZM4.48497 5.33252C4.87497 5.33252 5.20871 5.47127 5.48622 5.74877C5.76372 6.02627 5.90247 6.36002 5.90247 6.75002C5.90247 7.14002 5.76372 7.47002 5.48622 7.74002C5.20871 8.01002 4.87497 8.14502 4.48497 8.14502C4.09496 8.14502 3.76497 8.01002 3.49497 7.74002C3.22496 7.47002 3.08997 7.14002 3.08997 6.75002C3.08997 6.36002 3.22496 6.02627 3.49497 5.74877C3.76497 5.47127 4.09496 5.33252 4.48497 5.33252ZM4.48497 10.9575C4.87497 10.9575 5.20871 11.0963 5.48622 11.3738C5.76372 11.6513 5.90247 11.985 5.90247 12.375C5.90247 12.765 5.76372 13.095 5.48622 13.365C5.20871 13.635 4.87497 13.77 4.48497 13.77C4.09496 13.77 3.76497 13.635 3.49497 13.365C3.22496 13.095 3.08997 12.765 3.08997 12.375C3.08997 11.985 3.22496 11.6513 3.49497 11.3738C3.76497 11.0963 4.09496 10.9575 4.48497 10.9575Z'
                fill='currentColor'
            />
        </>
    ),
})

ChecklistsIcon.displayName = 'ChecklistsIcon'
